module.exports = __webpack_public_path__ + "img/Medication Management during Ramadan.7b76befc.jpg";